import React from 'react';
import DefaultSummary from './DefaultSummary';
import CiaSummary from './CiaSummary';
import CmaSummary from './CmaSummary';
import DifrSummary from './DifrSummary';
import { Consts } from '../../../res';

const Summary = (props) => {

    const renderSummary = () => {
        switch (props.theme) {
            case Consts.EXAM_THEMES.CIA:
                return <CiaSummary {...props} />;
            case Consts.EXAM_THEMES.CMA:
                return <CmaSummary {...props} />;
            case Consts.EXAM_THEMES.DIFR:
                return <DifrSummary {...props} />;
            default:
                return <DefaultSummary {...props} />;
        }
    };

    return renderSummary();
};

export default Summary;